import { useEffect } from 'react';
export default function useAsyncEffect(cb, inputs) {
    useEffect(function () {
        cb();
    }, inputs);
}
